import React, { useEffect } from "react";
import { Header } from "../sections/Header";
import { Hero } from "../sections/Hero";
import { CredentialsBar } from "../sections/CredentialsBar";
import { About } from "../sections/About";
import { Services } from "../sections/Services";
import { Forensic } from "../sections/Forensic";
import { Clients } from "../sections/Clients";
import { InsightsPreview } from "../sections/InsightsPreview";
import { FAQ } from "../sections/FAQ";
import { Contact } from "../sections/Contact";
import { Footer } from "../sections/Footer";
import { StickyCTA } from "../sections/StickyCTA";
import {
  Seo,
  ORGANIZATION_SCHEMA,
  WEBSITE_SCHEMA,
  PERSON_SCHEMA,
  buildFaqSchema,
  buildWebPageSchema,
} from "../components/Seo";
import { FAQS } from "../data/mock";

const Home = () => {
  useEffect(() => {
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 100);
      }
    }
  }, []);

  const title =
    "Forensic Accountant Attorney Texas | The Bufkin Law Firm";
  const description =
    "Texas forensic accounting and financial litigation firm led by Richard L. Bufkin — attorney, CPA, and AICPA-certified forensic accountant with 50+ years of experience in business, bankruptcy, family-law, and expert witness work.";

  return (
    <>
      <Seo
        title={title}
        description={description}
        path="/"
        keywords="forensic accountant Texas, business litigation attorney Dallas, CPA attorney, bankruptcy trustee representation, fraud detection lawyer, economic damages expert witness, Richard L. Bufkin, AICPA CFF, Mt. Pleasant Texas attorney"
        schemas={[
          ORGANIZATION_SCHEMA,
          WEBSITE_SCHEMA,
          PERSON_SCHEMA,
          buildWebPageSchema({ title, description, path: "/" }),
          buildFaqSchema(FAQS),
        ]}
      />
      <main data-testid="home-page" className="bg-ivory min-h-screen">
        <Header />
        <Hero />
        <CredentialsBar />
        <About />
        <Services />
        <Forensic />
        <Clients />
        <InsightsPreview />
        <FAQ />
        <Contact />
        <Footer />
        <StickyCTA />
      </main>
    </>
  );
};

export default Home;
